/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Maxim Fedorov
 * @author Ale
 * @version 1.0.5
 * @since 1.0.0
 */

import { borderColorLight, ColorWhite } from './palette';

export const dropDownFilterInputBorderColor = borderColorLight;
export const dropDownFilterBgColor = ColorWhite;
